import script from "./TdzCleanOrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./TdzCleanOrderList.vue?vue&type=script&setup=true&lang=js"

import "./TdzCleanOrderList.vue?vue&type=style&index=0&id=d87d401c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d87d401c"]])

export default __exports__